import { Values } from 'ha/constants/Facilities';

interface Room {
  facility_water_cost_included: string;
  facility_gas_cost_included: string;
  facility_electricity_included: string;
  facility_internet_included: string;
}

export default (room: Room) =>
  [
    room.facility_water_cost_included,
    room.facility_gas_cost_included,
    room.facility_electricity_included,
    room.facility_internet_included,
  ].every(included => included === Values.Yes);
